import { render } from "./HomeArticles.vue?vue&type=template&id=056afd3d&scoped=true"
import script from "./HomeArticles.vue?vue&type=script&lang=js"
export * from "./HomeArticles.vue?vue&type=script&lang=js"

import "./HomeArticles.vue?vue&type=style&index=0&id=056afd3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056afd3d"]])

export default __exports__